import comp from "./Textview";
export default comp;
